import { Box, BoxProps } from '@mui/material';
import React, { ReactEventHandler } from 'react';

type PageContentProps = {
  children?: React.ReactNode;
  onScroll?: ReactEventHandler<HTMLDivElement>;
  overflow?: BoxProps['overflow'];
  bgcolor?: BoxProps['bgcolor'];
  safeAreaBottomOffsetEnabled?: boolean;
  'data-testid'?: string;
};

export const PageContent = React.forwardRef<HTMLDivElement, PageContentProps>((props, ref) => {
  const {
    children,
    onScroll,
    overflow = 'auto',
    bgcolor = 'background.default',
    safeAreaBottomOffsetEnabled,
    'data-testid': dataTestId,
  } = props;
  return (
    <Box
      ref={ref}
      data-testid={dataTestId}
      onScroll={onScroll}
      display="flex"
      flex="1 1 0"
      flexDirection="column"
      position="relative"
      overflow={overflow}
      bgcolor={bgcolor}
      // https://developer.mozilla.org/en-US/docs/Web/CSS/contain
      sx={{
        contain: 'size layout style',
        mb: safeAreaBottomOffsetEnabled ? 'var(--ion-safe-area-bottom)' : undefined,
      }}>
      {children}
    </Box>
  );
});
